<template>
    <div class="main">
        <div class="completeSkeleton" v-for="(count, index) in counts" :key="index" :style="{gap: bulletGap, marginBottom: getSkeletonGap(index)}">
            <span v-if="showBullet" :style="{ height: height, width: height }"  class="bullet">
            </span>
            <span :style="{ height: height, width: getLineWidth(index) }" class="line">
            </span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    props: {
        height: {
            type: String,
            default: '1rem'
        },
        width: {
            type: String,
            default: '100%'
        },
        counts: {
            type: Number,
            default: 1
        },
        showBullet: {
            type: Boolean,
            default: false
        },
        gap: {
            type: String,
            default: '1rem'
        },
        bulletGap: {
            type: String,
            default: '0.5rem'
        },
        lineWidths: {
            type: Array,
            default: () => []
        },
        gaps: {
            type: Array,
            default: () => [] // Array of gaps between skeleton rows
        }
    },
    methods: {
        getLineWidth(index) {
            // If custom widths are provided, use them cyclically
            if (this.lineWidths && this.lineWidths.length > 0) {
                return this.lineWidths[index % this.lineWidths.length];
            }
            // Fallback to the original width prop
            return this.width;
        },
        getSkeletonGap(index) {
            // Don't add margin to the last skeleton
            if (index === this.counts - 1) {
                return '0';
            }
            
            // If custom gaps are provided, use them cyclically
            if (this.gaps && this.gaps.length > 0) {
                return this.gaps[index % this.gaps.length];
            }
            // Fallback to the original gap prop
            return this.gap;
        }
    }
}
</script>
<style scoped>
.main{
    display: flex;
    flex-direction: column;
    width: 100%;
}
.completeSkeleton{
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}
.bullet{
    border-radius: 0.25rem;
    background-color: #F3F4F6;
    min-width: 1rem;
    flex-shrink: 0;
}
.line{
    border-radius: 0.25rem;
    background-color: #F3F4F6;
    flex-shrink: 0;
}
    
</style>